// removed by extract-text-webpack-plugin
module.exports = {"deliveryProposition":"_36n_JsH","title":"_21tn5Nb","description":"_4ldbEX5","descriptionLink":"s1XF5zI"};


//////////////////
// WEBPACK FOOTER
// ./template/components/MiniBag/Footer/DeliveryProposition/index.css
// module id = ./template/components/MiniBag/Footer/DeliveryProposition/index.css
// module chunks = client.sitechrome